<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

export type Props = {
  txt: string
  to: RouteLocationRaw | undefined
  out?: boolean
  arrow?: boolean
  button?: boolean
  underline?: 'never'
  bold?: boolean
  big?: boolean
  small?: boolean
  medium?: 'never'
  icon?: boolean
  black?: boolean
  blue?: boolean
  border?: boolean
  border2?: boolean
}

const props = defineProps<Props>()

const css = useCssModule()
const uiClass = computed(() => {
  const { arrow, big, black, bold, border, border2, icon, out, small, blue, button } = props
  const arr = arrow || button
  const res: string[] = []

  if (out) res.push('_pr3')
  if (arrow) res.push('IconArrow')
  if (arr) res.push(css.arr2)

  if (big) res.push(icon ? '_pr4 _pl2' : '_pl4 _pr4')
  else if (arr) res.push('_pr3 _pl14')

  if (bold) res.push(css.bold)

  if (big) res.push(css.big)
  else if (small) res.push(css.small)

  if (bold) res.push('_fw-xxl')
  else if (big || arr) res.push('_fw-xl')

  if (black) res.push('black')
  if (blue) res.push('blue')
  if (icon) res.push('icon')
  if (border) res.push('border')
  if (border2) res.push('border2')

  return res
  // return [
  // big ? (icon ? '_pr4 _pl2' : '_pl4 _pr4') : arrow ? '_pr3 _pl14' : undefined,
  // bold && css.bold,
  // big && css.big,
  // small && css.small,
  // bold ? '_fw-xxl' : big || arrow ? '_fw-xl' : undefined,
  // { black, icon, border },
  // ]
})
</script>

<template>
  <LinkFalling :txt :to class="_hcont" :class="uiClass">
    <template v-if="out" #after><span :class="$style.out" /></template>
    <template v-else-if="arrow" #after
      ><slot :class-icon="$style.arr"><IconArrow :class="$style.arr" /></slot
    ></template>
  </LinkFalling>
</template>

<style module>
.bold::after {
  content: '';
  height: 1px;
  width: calc(100% - 8px);
  background: var(--black);
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  border-radius: 9px;
  margin: 0 auto;
}

.arr2 {
  composes: global(_fs09);
  composes: global(_ls-xs);
  composes: global(_wcont);

  composes: global(_pt02);
  composes: global(_pb02);

  composes: global(_br99);
  composes: global(_noflex);

  composes: global(_bg5);
  line-height: 24px;
}
.arr2:global(.black) {
  background: var(--black);
  color: var(--bg);
}
.arr2:global(.blue) {
  background: var(--blue3);
  color: var(--bg);
  --out-color: var(--blue3);
}
.arr2:global(.border) {
  background: var(--bg);
  color: var(--black);
  border: 1px solid var(--borderC, var(--black));
}
.arr2:global(.border2) {
  background: transparent;
  color: var(--black);
  border: 1px solid var(--borderC, var(--black));
  font-size: var(--fs-07);
  line-height: 18px;
}
.arr2:hover {
  color: var(--bg);
  --borderC: var(--blue3);
}

.arr {
  composes: global(_absolute);
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_svg16);
  composes: global(_br6);
  composes: global(_h100p);
  composes: global(_c45);

  top: 0;
  right: 6px;

  transition: transform 300ms var(--tran3);
}

.arr2:global(.border2) .arr {
  color: var(--black);
  --svg: 16px;
}

.arr2:hover .arr {
  transform: translate(4px);
  color: currentColor;
}
.arr2::before {
  content: '';
  display: block;
  width: 100%;
  position: absolute;
  opacity: 0.01;
  transition:
    clip-path 400ms cubic-bezier(0.23, 1, 0.32, 1) 100ms,
    opacity 0ms linear 500ms;
  overflow: hidden;
  contain: paint;
  background: var(--blue3);
  inset: 0;
  clip-path: inset(calc(100% - 7px) 7px 7px 7px round 99px);
}
.arr2:hover::before {
  opacity: 1;
  transition:
    clip-path 300ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0ms linear;
  clip-path: inset(0 0 0 0 round 99px);
}

.small {
  line-height: 30px;
  composes: global(_h34);
}

.big {
  line-height: 34px;
}
:global(.m) .big {
  line-height: 40px;
}
.big .arr {
  right: 8px;
}
.big:global(.icon):global(.black) .arr {
  color: var(--bg);
}

.out {
  composes: global(_absolute);
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_h100p);
  composes: global(_w20);
  right: 0;
  top: 0;
}
.out::after {
  content: '\002197';
  font-family:
    'Helvetica Neue',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    'Arial',
    sans-serif;
  background: var(--black-5);
  height: 14px;
  width: 14px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 4px;
  font-size: var(--fs07);
  display: inline-flex;
  color: var(--out-color);
}
.arr2:hover .out::after {
  --out-color: var(--blue3);
}
</style>
